import React from 'react';
import './BgVideoContainer.css';

const BgVideoContainer = ({ videoSrc, animClass = '', className = '' }) => {
  return (
    <div className={`bg-video-container ${animClass} ${className}`.trim()}>
      {videoSrc?.includes('.gif') ? (
        <img src={videoSrc} className='bg-video' alt='' aria-hidden='true' />
      ) : (
        <video
          autoPlay
          loop
          muted
          playsInline
          preload='auto'
          className='bg-video'
          aria-hidden='true'
        >
          <source src={videoSrc} type='video/mp4' />
        </video>
      )}
    </div>
  );
};

export default BgVideoContainer;
